import type React from "react";
import { Redirect } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

interface AuthenticatedRoutesProps {
  children: React.ReactNode;
}

export function AuthenticatedRoutes({ children }: AuthenticatedRoutesProps) {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Redirect to="/login" />;
  }

  return children;
}
